import { FontConfig } from "@/domains/design/types"
import { ResponsiveMode } from "@/hooks/use-responsive"

export const getConfigForMode = (config: FontConfig, mode: ResponsiveMode | undefined) => {
  if (mode === "desktop") {
    return config.desktop
  } else if (mode === "tablet") {
    return config.tablet
  } else if (mode === "mobile") {
    return config.mobile
  }
  return config.desktop
}
